module.exports = __webpack_public_path__ + "img/4.00d2cedd.png";